import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  supportTitle: {
    id: 'zendesk.supportTitle',
    description: 'Title for the support button',
    defaultMessage: 'edX Support',
  },
  selectTicketForm: {
    id: 'zendesk.selectTicketForm',
    description: 'Select ticket form',
    defaultMessage: 'Please choose your request type:',
  },
});

export default messages;
